// frontend/src/components/games/sudoku/SudokuBoard.tsx

import { CellPosition, SudokuCell } from '../../../hooks/games/useSudokuGame';

interface SudokuBoardProps {
  cells: SudokuCell[][];
  selected: CellPosition | null;
  onSelect: (row: number, col: number) => void;
}

export function SudokuBoard({ cells, selected, onSelect }: SudokuBoardProps) {
  return (
    <div className="sudoku-board">
      {cells.map((row, rowIndex) =>
        row.map((cell, colIndex) => {
          const isSelected = !!selected && selected.row === rowIndex && selected.col === colIndex;
          const isPeer =
            !!selected &&
            !isSelected &&
            (selected.row === rowIndex ||
              selected.col === colIndex ||
              (Math.floor(selected.row / 3) === Math.floor(rowIndex / 3) &&
                Math.floor(selected.col / 3) === Math.floor(colIndex / 3)));

          const classNames = [
            'sudoku-cell',
            cell.isFixed ? 'fixed' : 'editable',
            cell.isError ? 'error' : '',
            isSelected ? 'selected' : '',
            isPeer ? 'peer' : '',
            colIndex % 3 === 0 ? 'box-left' : '',
            colIndex === 8 ? 'box-right' : '',
            rowIndex % 3 === 0 ? 'box-top' : '',
            rowIndex === 8 ? 'box-bottom' : '',
          ].filter(Boolean).join(' ');

          return (
            <button
              key={`${rowIndex}-${colIndex}`}
              type="button"
              className={classNames}
              onClick={() => onSelect(rowIndex, colIndex)}
            >
              {cell.value !== 0 ? cell.value : ''}
            </button>
          );
        })
      )}
    </div>
  );
}
